// @flow

import * as React from 'react';
import s from './ButtonPrimary.scss';

type Props = {
  label: string,
  onClick: () => void,
  disabled: boolean,
  size: string, // large, medium, small
  as : React.ElementType,
  addClass?: string, //any external class required to add
}

export const ButtonPrimary = (props: Props) => {
  const { label, disabled, size, as, addClass, ...componentProps } = props;
  let classes = [];
  const sizeGiven = size && ['large', 'medium', 'small'].indexOf(size.toLowerCase()) !== -1;
  if (sizeGiven) {
    classes.push(s[size])
  }
  if(disabled){
    classes.push(s.disabled)
  }
  if(addClass){
    classes.push(addClass);
  }
  const Comp = as ? as : 'button';
  return (
    <Comp
      // default test id in case none provided
      data-testid="button-primary"
      className={classes.join(' ')}
      disabled={disabled}
      {...componentProps}
    >
      {label}
    </Comp>
  );
}

export default ButtonPrimary;
